import { RootState } from "../../../store";
import { ResourceExplorerDataGridView } from "../../utils/types/resourceExplorerDataGrid";
import { resourceExplorerStateSelector } from "../resourceExplorerStateSelector";

export const resourceExplorerDataGridViewSelector = (
  state: RootState,
): ResourceExplorerDataGridView | null => {
  return resourceExplorerStateSelector(state).dataGridView;
};
